import React from 'react';
import classNames from 'classnames/bind.js';
import proptypes from 'prop-types';
const { bool, func, node } = proptypes;

import { Image } from '@thd-olt-component-react/core-ui';

import styles from './modal-container.module.scss';

const cx = classNames.bind(styles);

const CloseButton = ({ handleClose }) => {
  return (
    <div
      className={cx('modal-overlay__close')}
      role="button"
      tabIndex={0}
      onClick={handleClose}
      data-testid="modal-overlay-close-button"
    >
      <Image
        asset="close-x-grey.svg"
        height={15}
        width={15}
        title="Modal Close"
        alt="close-x-grey"
      />
    </div>
  );
};

CloseButton.propTypes = {
  handleClose: func.isRequired
};

export const ModalContainer = ({ closeIcon, show, onClose, children }) => {
  return (
    <div
      className={cx('modal-overlay', `modal-overlay__${show ? 'active' : 'inactive'}`)}
      data-testid="modal-container"
    >
      <div className={cx('modal-overlay__container')}>
        <div className={cx('modal-overlay__body')}>
          {closeIcon && (
            <CloseButton handleClose={onClose} />
          )}
          <div
            className={cx('modal-overlay__content')}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

ModalContainer.displayName = 'ModalContainer';

ModalContainer.propTypes = {
  closeIcon: bool,
  onClose: func,
  show: bool.isRequired,
  children: node.isRequired
};

ModalContainer.defaultProps = {
  closeIcon: true,
  onClose: () => {}
};
